/**
 * External dependencies
 */
import { useMatomo } from '@datapunt/matomo-tracker-react';

type TrackEventParams = {
	category: string;
	action: string;
	label?: string;
	value?: number;
}

const useAnalytics = () : {
	trackEvent: ( params: TrackEventParams ) => void | undefined;
} => {
	const { trackEvent: trackEventMatomo } = useMatomo();

	const trackEvent = ( {
		category,
		action,
		label,
		value,
	}: TrackEventParams ) => {
		trackEventMatomo( {
			category,
			action,
			name: label,
			value,
		} );
	};

	return { trackEvent };
};

export default useAnalytics;
